import React from 'react';

import { ThemeProvider, createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  typography: {
    // Tell Material-UI what's the font-size on the html element is.
    htmlFontSize: 10,
    h1: {
      fontSize: 32,
      fontFamily: 'SofiaProBold',
      // letterSpacing: 5,
    },
    h2: {
      fontSize: 30,
      fontFamily: 'SofiaProBold',
      letterSpacing: 5,
    },
    h3: {
      fontSize: 24,
      fontFamily: 'SofiaProBold',
      // letterSpacing: 5,
    },
    h4: {
      fontSize: 20,
      fontFamily: 'SofiaProBold',
      // letterSpacing: 5,
    },
    h5: {
      fontSize: 16,
      fontFamily: 'SofiaProBold',
      // letterSpacing: 5,
    },
    h6: {
      fontSize: 12,
      fontFamily: 'SofiaProBold',
      // letterSpacing: 5,
    },
    subtitle1: {
      fontSize: 20,
      fontFamily: 'SofiaProBold',
    },
    subtitle2: {
      fontSize: 14,
      fontFamily: 'SofiaProBold',
    },
    body1: {
      fontSize: 16,
      fontFamily: 'FiraSans',
    },
    body2: {
      fontSize: 20,
      fontFamily: 'FiraSans',
    },
  },
  palette: {
    black: '#000',
    white: '#FFF',
    darkGrey: '#696A76',
    lightGrey: '#818293',
    primary: {
      main: '#A6E10F',
    },
  },
});

export const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);
